import { ConciergeProvider } from '@context/ConciergeProvider'
import { WisdomProvider } from '@context/WisdomProvider'
import { Outlet } from 'react-router-dom'
import OnboardingWrapper from '@components/OnboardingWrapper'

export default function WebConciergeLayout() {
  return (
    <ConciergeProvider>
      <WisdomProvider>
        <OnboardingWrapper>
          <Outlet />
        </OnboardingWrapper>
      </WisdomProvider>
    </ConciergeProvider>
  )
}
